import { mapState } from "../../store/map";
export default {
  name: "CategoryList",
  setup: function setup() {
    window.scrollTo({
      top: 0
    });

    var _mapState = mapState("categoryAbout"),
        categoryCounts = _mapState.categoryCounts;

    return {
      categoryCounts: categoryCounts
    };
  }
};